import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"

// REJECTED is intentionally excluded — rejected drafts revert to EDITING on save
export function isScheduleEditable(schedule) {
    const { draftStatus } = schedule
    return draftStatus !== DraftStatus.SUBMITTED && draftStatus !== DraftStatus.APPROVED
}
